<template>
	<div>
		<transition name="fade" mode="out-in">
			<div v-if="sitetype" :key="0">
				<transition name="fade" mode="out-in">
					<v-progress-circular v-if="loadingSite" :size="50" :width="3" :color="ada.pink"
															 indeterminate
					></v-progress-circular>
					<div v-else>
						<Datatable :loading="loading" :items="items" :headers="headers" itemSlot="item:env" title="Deployments"
											 :items-per-page="15"
											 @click:json="showJson" @click:row="showJson">
							<template #item:env="item">
								<v-chip class="font-weight-bold" dark label small
												:color="item.env === 'stage' ? ada.blue : ada.pink">
									{{ item.env.toUpperCase() }}
								</v-chip>
							</template>
						</Datatable>
					</div>
				</transition>
			</div>
			<div v-else :style="{minHeight:'30vh'}" class="noSiteSelected" :key="1">
				Bitte eine Seite zum Bearbeiten auswählen.
			</div>
		</transition>
		<Dialog v-model="showJsonDialog" title="JSON Editor History Eintrag" hide-buttons width="1000px">
			<AceEditor
				v-model="historyJSON"
				@init="initEditor"
				lang="json"
				theme="chrome"
				width="100%"
				height="700"
				:options="aceConfig"
			/>
		</Dialog>
	</div>
</template>

<script>
import ada from "../../scss/ada_colors.scss";
import Utils from "../../scripts/Utils";
import axios from "axios";
import AceEditor from 'vuejs-ace-editor';
import Datatable from "../../components/Tables/Datatable";
import Dialog from "../../components/Dialog";

export default {
	name: "JsonHistory",
	components: {AceEditor, Dialog, Datatable},
	props: ['site', 'sitetype'],
	data: () => {
		return {
			history: [],
			loading: false,
			headers: [
				{text: 'Umgebung', value: 'env', width: '120px', align: 'center'},
				{text: 'Beschreibung', value: 'description'},
				{text: 'User', value: 'user', width: '280px'},
				{text: 'Datum', value: 'created_at', width: '200px'},
				{text: 'Aktion', value: 'action', width: '150px', sortable: false},
			],
			selected: null,
			showJsonDialog: false,
			historyJSON: null,
			ada
		}
	},
	mounted() {
		this.init();
	},
	computed: {
		loadingSite() {
			return this.$store.state.editor.loadingSite;
		},
		items() {
			let ret = [];
			if (this.history) {
				this.history.forEach((entry) => {
					let tmp = JSON.parse(JSON.stringify(entry));
					tmp.created_at = Utils.formatDate(tmp.created_at, true);
					tmp.action = ['json'];
					tmp.user = Utils.getName(tmp.user);
					ret.push(tmp)
				})
			}
			return ret;
		},
		aceConfig() {
			let ret = JSON.parse(JSON.stringify(this.$store.state.aceConfig));
			ret.readOnly = true;
			return ret;
		},

	},
	methods: {
		init() {
			if (this.sitetype) {
				this.fetchHistory();
			}
		},
		fetchHistory() {
			this.loading = true;
			let baseUrl = process.env.NODE_ENV === "development" ? 'http://localhost:3000' : process.env.VUE_APP_JSON_EDITOR_URL;
			axios.get(`${baseUrl}/api/history/${this.sitetype.SitetypeId}${Utils.appendCorsParam()}`, {
				headers: {
					'X-API-KEY': process.env.VUE_APP_X_API_KEY,
				}
			})
				.then((res) => {
					if (res.status) {
						this.history = res.data.result;
					}
					this.loading = false;
				})
				.catch((error) => {
					this.loading = false;
					this.history = error;
					this.$root.$emit('snackbar', 'JSON History: ' + error, 'error')
				})
		},
		showJson(entry) {
			this.selected = entry;
			let parsedJSON;
			try {
				parsedJSON = JSON.stringify(JSON.parse(entry.json), null, 1);
			} catch (e) {
				this.$root.$emit('snackbar', 'Evtl. fehlerhafte Darstellung. JSON konnte nicht richtig geparsed werden.', 'warning');
			}
			this.historyJSON = parsedJSON || entry.json;
			this.showJsonDialog = true;
		},
		initEditor() {
			require('brace/ext/searchbox'); //language extension prerequsite...
			require('brace/ext/language_tools'); //language extension prerequsite...
			require('brace/mode/json');    //language
			require('brace/snippets/json')
			require('brace/theme/chrome');
		},
	},
	watch: {
		sitetype() {
			if (this.sitetype) {
				this.init();
			}
		}
	}
}
</script>

<style scoped>

</style>